<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
  }>();
</script>

<template>
  <th
    :class="
      cn(
        'text-sm text-left text-muted-foreground bg-table-header font-medium align-middle',
        props.class,
      )
    "
  >
    <slot />
  </th>
</template>
